import { getRequest } from "../http/index";

export const correctorLink = (link: string) => {
  const url = `${import.meta.env.VITE_CORRETOR_LINK}?link=${link}`;

  return getRequest(url);
};

export const producerLink = (link: string, corretorEv: string) => {
  const url = `${import.meta.env.VITE_PRODUCER_LINK}?link=${link}&ev=${corretorEv}`;

  return getRequest(url);
}
